import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identificar el bucle",
    opening: localizedGenderNode(
      [
      "Hoy no resuelvo. Solo reconozco: es la misma discusión, el mismo camino."
    ],
      [
      "Hoy no resuelvo. Solo reconozco: es la misma discusión, el mismo camino."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración.",
      "En mi corazón: “Esto es un bucle. No soy yo.”"
    ],
      [
      "Pausa conmigo.",
      "Una respiración.",
      "En mi corazón: “Esto es un bucle. No soy yo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura — para mí\n¿Cuál es el tema que vuelve una y otra vez?",
      "¿Cuál es la primera frase que normalmente lo enciende?",
      "¿Cómo suele terminar?"
    ],
      [
      "Escritura — para mí\n¿Cuál es el tema que vuelve una y otra vez?",
      "¿Cuál es la primera frase que normalmente lo enciende?",
      "¿Cómo suele terminar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando reconozco el bucle — ya tengo poder."
    ],
      [
      "Cierre",
      "Cuando reconozco el bucle — ya tengo poder."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Esto es un bucle.” + una respiración. No continúo la discusión en mi cabeza.",
      "Una vez hoy: “Esto es un bucle.” + una respiración. No continúo la discusión en mi cabeza."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer disparador: qué me activa",
    opening: localizedGenderNode(
      [
      "Hoy veo qué me activa antes de responder."
    ],
      [
      "Hoy veo qué me activa antes de responder."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es el disparador que me enciende? (palabra/tono/mirada/hora/cansancio)",
      "¿Qué siento en el primer segundo? (ira/dolor/miedo/vergüenza)",
      "¿Qué necesito en ese momento que no sé cómo decir?"
    ],
      [
      "Escritura\n¿Cuál es el disparador que me enciende? (palabra/tono/mirada/hora/cansancio)",
      "¿Qué siento en el primer segundo? (ira/dolor/miedo/vergüenza)",
      "¿Qué necesito en ese momento que no sé cómo decir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "A veces la discusión es solo un envoltorio para una necesidad."
    ],
      [
      "Cierre",
      "A veces la discusión es solo un envoltorio para una necesidad."
    ]
    ),
    action: localizedGenderNode(
      "Cuando sube el disparador: mano en el pecho + una respiración antes de una palabra.",
      "Cuando sube el disparador: mano en el pecho + una respiración antes de una palabra."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que realmente estoy intentando conseguir",
    opening: localizedGenderNode(
      [
      "Hoy pregunto: qué quiero de verdad — debajo de la pelea."
    ],
      [
      "Hoy pregunto: qué quiero de verdad — debajo de la pelea."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nCuando entro en esta discusión — ¿qué estoy intentando conseguir?",
      "¿Busco justicia, cercanía, reconocimiento, seguridad?",
      "¿Qué petición simple se esconde debajo?"
    ],
      [
      "Escritura\nCuando entro en esta discusión — ¿qué estoy intentando conseguir?",
      "¿Busco justicia, cercanía, reconocimiento, seguridad?",
      "¿Qué petición simple se esconde debajo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una petición clara es mejor que una guerra."
    ],
      [
      "Cierre",
      "Una petición clara es mejor que una guerra."
    ]
    ),
    action: localizedGenderNode(
      "Formulo una petición corta — solo para mí.",
      "Formulo una petición corta — solo para mí."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Qué puede escuchar la otra parte",
    opening: localizedGenderNode(
      [
      "Hoy reviso cómo podría sonar del otro lado."
    ],
      [
      "Hoy reviso cómo podría sonar del otro lado."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración. “Una buena intención puede sonar como un ataque.”"
    ],
      [
      "Pausa conmigo.",
      "Una respiración. “Una buena intención puede sonar como un ataque.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nCuando digo mis frases — ¿cómo podrían escucharse?",
      "¿Cuál de mis frases suena como una acusación?",
      "¿Cómo puedo decirlo como “Yo siento…” en vez de “Tú siempre…”?"
    ],
      [
      "Escritura\nCuando digo mis frases — ¿cómo podrían escucharse?",
      "¿Cuál de mis frases suena como una acusación?",
      "¿Cómo puedo decirlo como “Yo siento…” en vez de “Tú siempre…”?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El lenguaje suave no significa que me rinda. Significa que soy sabio/a."
    ],
      [
      "Cierre",
      "El lenguaje suave no significa que me rinda. Significa que soy sabio/a."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy cambio “Tú…” por “Yo…”",
      "Una vez hoy cambio “Tú…” por “Yo…”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El punto de no retorno",
    opening: localizedGenderNode(
      [
      "Hoy identifico cuándo la discusión ya no es sobre el tema."
    ],
      [
      "Hoy identifico cuándo la discusión ya no es sobre el tema."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es la señal de que llegamos al punto de no retorno? (tono/gritos/desprecio/bloqueo)",
      "¿Qué suelo hacer ahí?",
      "¿Qué me gustaría hacer en su lugar? (pausa/agua/espacio)"
    ],
      [
      "Escritura\n¿Cuál es la señal de que llegamos al punto de no retorno? (tono/gritos/desprecio/bloqueo)",
      "¿Qué suelo hacer ahí?",
      "¿Qué me gustaría hacer en su lugar? (pausa/agua/espacio)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Salir del bucle a tiempo es madurez."
    ],
      [
      "Cierre",
      "Salir del bucle a tiempo es madurez."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una “palabra de alto” para mí: “Pausa.” Luego una respiración.",
      "Elijo una “palabra de alto” para mí: “Pausa.” Luego una respiración."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Un descanso respetuoso (no abandono)",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a tomar un descanso sin hacer daño."
    ],
      [
      "Hoy aprendo a tomar un descanso sin hacer daño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me asusta de parar una discusión a la mitad?",
      "¿Cómo suena un descanso respetuoso en una sola frase?",
      "¿Cuánto descanso necesito para volver más calmado/a?"
    ],
      [
      "Escritura\n¿Qué me asusta de parar una discusión a la mitad?",
      "¿Cómo suena un descanso respetuoso en una sola frase?",
      "¿Cuánto descanso necesito para volver más calmado/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un descanso protege la relación. No es huir."
    ],
      [
      "Cierre",
      "Un descanso protege la relación. No es huir."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una “frase de descanso” fija para mí.",
      "Escribo una “frase de descanso” fija para mí."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Lo que traigo del pasado",
    opening: localizedGenderNode(
      [
      "Hoy veo qué se activa en mí más allá del presente."
    ],
      [
      "Hoy veo qué se activa en mí más allá del presente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuándo en mi vida me he sentido así antes? (sin profundizar — solo notar)",
      "¿Qué herida antigua se activa en este bucle?",
      "¿Qué necesitaba entonces y no recibí?"
    ],
      [
      "Escritura\n¿Cuándo en mi vida me he sentido así antes? (sin profundizar — solo notar)",
      "¿Qué herida antigua se activa en este bucle?",
      "¿Qué necesitaba entonces y no recibí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "A veces peleamos en el presente con un dolor viejo."
    ],
      [
      "Cierre",
      "A veces peleamos en el presente con un dolor viejo."
    ]
    ),
    action: localizedGenderNode(
      "Cuando sube: “Esto es un dolor viejo pidiendo seguridad.”",
      "Cuando sube: “Esto es un dolor viejo pidiendo seguridad.”"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Separar conducta de identidad",
    opening: localizedGenderNode(
      [
      "Hoy dejo de convertir la discusión en “quién eres”."
    ],
      [
      "Hoy dejo de convertir la discusión en “quién eres”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué frases lo vuelven personal? (“Eres esto”, “Siempre eres…”)",
      "¿Cómo puedo hablar de conductas sin atacar la identidad?",
      "¿Qué es lo que realmente quiero cambiar en la práctica?"
    ],
      [
      "Escritura\n¿Qué frases lo vuelven personal? (“Eres esto”, “Siempre eres…”)",
      "¿Cómo puedo hablar de conductas sin atacar la identidad?",
      "¿Qué es lo que realmente quiero cambiar en la práctica?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La conducta puede cambiar. La humillación destruye."
    ],
      [
      "Cierre",
      "La conducta puede cambiar. La humillación destruye."
    ]
    ),
    action: localizedGenderNode(
      "Practico esta frase: “Hablo de lo que pasó, no de quién eres.”",
      "Practico esta frase: “Hablo de lo que pasó, no de quién eres.”"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Mi límite en una discusión",
    opening: localizedGenderNode(
      [
      "Hoy defino qué no es aceptable para mí durante una pelea."
    ],
      [
      "Hoy defino qué no es aceptable para mí durante una pelea."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es mi límite en una discusión? (gritos/insultos/bloqueo/amenazas)",
      "¿Qué hago cuando se cruza?",
      "¿Qué estoy dispuesto/a a hacer para proteger ese límite?"
    ],
      [
      "Escritura\n¿Cuál es mi límite en una discusión? (gritos/insultos/bloqueo/amenazas)",
      "¿Qué hago cuando se cruza?",
      "¿Qué estoy dispuesto/a a hacer para proteger ese límite?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite no es castigo. Es protección."
    ],
      [
      "Cierre",
      "Un límite no es castigo. Es protección."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un límite claro en una sola frase.",
      "Escribo un límite claro en una sola frase."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición en lugar de una lista",
    opening: localizedGenderNode(
      [
      "Hoy pido una cosa clara — no diez."
    ],
      [
      "Hoy pido una cosa clara — no diez."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es la petición más importante que tengo dentro de este bucle?",
      "¿Cómo suena corta, clara, sin culpa?",
      "¿Qué estoy dispuesto/a a dar a cambio? (lenguaje/tiempo/esfuerzo)"
    ],
      [
      "Escritura\n¿Cuál es la petición más importante que tengo dentro de este bucle?",
      "¿Cómo suena corta, clara, sin culpa?",
      "¿Qué estoy dispuesto/a a dar a cambio? (lenguaje/tiempo/esfuerzo)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una petición real crea la posibilidad de movimiento."
    ],
      [
      "Cierre",
      "Una petición real crea la posibilidad de movimiento."
    ]
    ),
    action: localizedGenderNode(
      "Practico decir mi petición en voz alta para mí una vez.",
      "Practico decir mi petición en voz alta para mí una vez."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Reparar después de una pelea",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a reparar sin borrar."
    ],
      [
      "Hoy aprendo a reparar sin borrar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué fue lo más hiriente que dije o hice en este bucle?",
      "¿Cómo puedo asumir responsabilidad sin justificarme?",
      "¿Qué frase de reparación me gustaría escuchar?"
    ],
      [
      "Escritura\n¿Qué fue lo más hiriente que dije o hice en este bucle?",
      "¿Cómo puedo asumir responsabilidad sin justificarme?",
      "¿Qué frase de reparación me gustaría escuchar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La reparación construye confianza."
    ],
      [
      "Cierre",
      "La reparación construye confianza."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una “frase de reparación” corta.",
      "Escribo una “frase de reparación” corta."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Elegir el momento adecuado para hablar",
    opening: localizedGenderNode(
      [
      "Hoy dejo de intentar arreglar cosas cuando estamos agotados."
    ],
      [
      "Hoy dejo de intentar arreglar cosas cuando estamos agotados."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuándo solemos pelear? (noche/cansancio/estrés)",
      "¿Cuándo hay más posibilidad de una buena conversación?",
      "¿Cómo puedo sugerir otro momento sin sonar como si evitara?"
    ],
      [
      "Escritura\n¿Cuándo solemos pelear? (noche/cansancio/estrés)",
      "¿Cuándo hay más posibilidad de una buena conversación?",
      "¿Cómo puedo sugerir otro momento sin sonar como si evitara?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El momento es la mitad de la solución."
    ],
      [
      "Cierre",
      "El momento es la mitad de la solución."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una posible “ventana de conversación” para esta semana.",
      "Elijo una posible “ventana de conversación” para esta semana."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Lo que realmente necesitamos como pareja",
    opening: localizedGenderNode(
      [
      "Hoy miro la necesidad debajo del bucle."
    ],
      [
      "Hoy miro la necesidad debajo del bucle."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué falta entre nosotros que alimenta el bucle? (seguridad/escucha/tiempo/respeto)",
      "¿Qué funciona entre nosotros cuando está bien?",
      "¿Qué cambio pequeño podría mejorar un 10%?"
    ],
      [
      "Escritura\n¿Qué falta entre nosotros que alimenta el bucle? (seguridad/escucha/tiempo/respeto)",
      "¿Qué funciona entre nosotros cuando está bien?",
      "¿Qué cambio pequeño podría mejorar un 10%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No hace falta una revolución. A veces un 10% alcanza."
    ],
      [
      "Cierre",
      "No hace falta una revolución. A veces un 10% alcanza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un cambio pequeño para esta semana.",
      "Elijo un cambio pequeño para esta semana."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre: una frase de regreso para el próximo bucle",
    opening: localizedGenderNode(
      [
      "Hoy me voy con una frase que me devuelve a mí en tiempo real."
    ],
      [
      "Hoy me voy con una frase que me devuelve a mí en tiempo real."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pausa conmigo.",
      "Una respiración."
    ],
      [
      "Pausa conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué aprendí sobre este bucle?",
      "¿Cuál es la señal más temprana de que estoy entrando?",
      "Frase de regreso al “momento antes” (corta, de bolsillo):"
    ],
      [
      "Escritura\n¿Qué aprendí sobre este bucle?",
      "¿Cuál es la señal más temprana de que estoy entrando?",
      "Frase de regreso al “momento antes” (corta, de bolsillo):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No tengo que ganar la discusión para estar a salvo.",
      "Quiero una relación con respeto — incluso cuando duele.",
      "Y empiezo con esto: una pausa. Una respiración. Una palabra menos."
    ],
      [
      "Cierre final del viaje",
      "No tengo que ganar la discusión para estar a salvo.",
      "Quiero una relación con respeto — incluso cuando duele.",
      "Y empiezo con esto: una pausa. Una respiración. Una palabra menos."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: elijo calma en lugar de reacción.",
      "Una vez hoy: elijo calma en lugar de reacción."
    ),
  },
].map(buildNormalizedDay);

export const repeatingConflictsInRelationshipBlueprintEs = buildNormalizedPilotBlueprint({
  id: "repeating_conflicts_in_relationship_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "repeating_conflicts_in_relationship",
  category: "general",
  journeyName: {
    he: "מריבות חוזרות (אותו סיפור שוב ושוב)",
    en: "Repeating Conflicts (The Same Story Again and Again)",
    es: "Conflictos repetidos (La misma historia una y otra vez)",
  },
  days,
});

export default repeatingConflictsInRelationshipBlueprintEs;
